// extracted by mini-css-extract-plugin
module.exports = {"pill":"CompareThisButton_pill__VJmxV"};